/**
 * ② MATERIALITY INTELLIGENCE — WITH DRILL-DOWN
 * UC-03: MaterialityAssessment — Double Materiality topic drill
 */
import { useState, useEffect } from "react";
import { C, api, post, Btn, Card, Label, Val, Badge, Err, MetricBar,
         Breadcrumb, DrillRow, DetailPanel, TabBar, HistoryTab, EmptyState, KPICard } from "./shared";

// ═══ UC-03: MATERIALITY ASSESSMENT — topic drill ═══
export function MaterialityAssessment() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sel, setSel] = useState(null);

  const assess = async () => {
    setLoading(true);
    try { setResult(await post("/materiality/assess-industry", { industry: "manufacturing" })); }
    catch (e) {} setLoading(false);
  };
  useEffect(() => { assess(); }, []);

  const topics = result?.topics || result?.material_topics || [];
  return (<div data-testid="materiality-assessment-panel">
    <Breadcrumb path={[{ label: "Materiality", onClick: () => setSel(null) }, ...(sel ? [{ label: sel.topic || sel.name }] : [])]} />

    {!sel && <>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <KPICard label="Material Topics" value={topics.filter(t => t.material || t.verdict === "material").length} color={C.purple} />
        <KPICard label="Not Material" value={topics.filter(t => !t.material && t.verdict !== "material").length} color={C.muted} />
      </div>
      {topics.map((t, i) => (
        <DrillRow key={i} onClick={() => setSel(t)} cols={[
          <span style={{ fontWeight: 600 }}>{t.topic || t.name}</span>,
          t.esrs_topic || t.esrs || "—",
          <Badge text={t.material || t.verdict === "material" ? "Material" : "Not Material"}
            color={t.material || t.verdict === "material" ? C.purple : C.dim} />
        ]} />
      ))}
    </>}

    {sel && (
      <DetailPanel visible onClose={() => setSel(null)} title={sel.topic || sel.name} color={C.purple}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
          <div><Label>Impact</Label><Val color={C.purple}>{sel.impact || sel.impact_materiality || "—"}</Val></div>
          <div><Label>Financial</Label><Val color={C.blue}>{sel.financial || sel.financial_materiality || "—"}</Val></div>
          <div><Label>Verdict</Label><Badge text={sel.material || sel.verdict === "material" ? "Material" : "Not Material"} color={C.purple} /></div>
        </div>
        {sel.rationale && <div style={{ marginTop: 8 }}><Label>Rationale</Label><div style={{ fontSize: 11, lineHeight: 1.5 }}>{sel.rationale}</div></div>}
      </DetailPanel>
    )}
  </div>);
}
